import ConfigConnected from '@clearkit/icons/indicators/ConfigConnected';
import ConfigDisconnected from '@clearkit/icons/indicators/ConfigDisconnected';
import SpinnerMono from '@clearkit/icons/indicators/SpinnerMono';

const successColor = 'green-600';
const dangerColor = 'red';
const idleColor = 'gray-600';

function IntegrationStatus({
  accountConnector,
  subIntegrationsData,
  subIntegrationsLoaded,
}) {
  const syncStatus = accountConnector.remoteMeta.syncStatus;

  if (!subIntegrationsLoaded) {
    return <SpinnerMono />;
  }

  const isConfigured = subIntegrationsData.some((data) => data.enabled);

  return (
    <>
      <StatusIcon syncStatus={syncStatus} isConfigured={isConfigured} />
      <div className={`ml-1 font-medium text-sm text-${textColor(syncStatus)}`}>
        {statusText(syncStatus, isConfigured)}
      </div>
    </>
  );
}

function statusText(syncStatus, isConfigured) {
  if (syncStatus == 'error') {
    return 'Error';
  } else if (isConfigured) {
    return 'Enriching';
  } else {
    return 'Unconfigured';
  }
}

function textColor(syncStatus, isConfigured) {
  if (syncStatus == 'error') {
    return dangerColor;
  } else if (isConfigured) {
    return successColor;
  } else {
    return idleColor;
  }
}

function StatusIcon({ syncStatus, isConfigured }) {
  if (syncStatus == 'error') {
    return <ConfigDisconnected height="20" width="20" />;
  } else if (isConfigured) {
    return <ConfigConnected height="20" width="20" />;
  } else {
    return <IdleConfigIcon height="20" width="20" />;
  }
}
// This is a hack since we don't currently have this icon in grey and we can't add to clearkit right now
function IdleConfigIcon(props) {
  const overrideColorStyle = {
    filter:
      'brightness(0) saturate(100%) invert(38%) sepia(5%) saturate(749%) hue-rotate(166deg) brightness(98%) contrast(97%)',
  };
  return <ConfigConnected style={overrideColorStyle} {...props} />;
}
export default IntegrationStatus;
